import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchReferralRewardTableColumnNames, fetchAllReferralReward, createReferralReward, updateReferralReward, 
    deleteReferralReward, activateDeactivateReferralReward, updateUserPreference,
    fetchTranslation,
    fetchCountry} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import AddReferralRewardForm from "../../../Components/Common/AddReferralRewardForm/AddReferralRewardForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";


const labels = [
  {
    id: 1,
    labelName: "Referral Name English",
    fieldName: "text-box-translate",
    name: "ReferralNameEn",
    value: "ReferralNameEn",
    required: true,
    translateTo: "ReferralNameAr", 
    errorMessage:"Referral English Is Required",
  },
  {
    id: 2,
    labelName: "Referral Name Arabic",
    fieldName: "text-box",
    name: "ReferralNameAr",
    value: "ReferralNameAr",
    required: true,
    errorMessage:"Referral Arabic Is Required",
  },
  {
    id: 3,
    labelName: "Cash",
    fieldName: "number-box",
    name: "Cash",
    value: "Cash",
    required: true,
    errorMessage:"Cash Is Required",
  },
  {
    id: 4,
    labelName: "Voucher",
    fieldName: "number-box",
    name: "Voucher",
    value: "Voucher",
    required: true,
    errorMessage:"Voucher Is Required",
  },
  {
    id: 5,
    labelName: "Coin",
    fieldName: "number-box",
    name: "Coin",
    value: "Coin",
    required: true,
    errorMessage:"Coin Is Required",
  },
  {
    id: 6,
    labelName: "Referend Amount",
    fieldName: "number-box",
    name: "ReferendAmount",
    value: "ReferendAmount",
    required: true,
    errorMessage:"Referend Amount Is Required",
  },
   {
    id: 7,
    labelName: "Countries",
    fieldName: "multiselect-dropdown",
    name: "CountryIDs",
    value: "CountryIDs",
    required: true,
    errorMessage:"Days are Required",
  },
  {
    id: 8,
    labelName: "Referral Document",
    fieldName: "file",
    name: "DocumentURL",
    value: "DocumentURL",
    required: true,
    errorMessage: "Please Select Document",
  },
  {
    id: 9,
    labelName: "Percentage",
    fieldName: "check-box",
    name: "IsPercentage",
    value: "IsPercentage",
    required: false,
  }
]

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};


function ReferralReward () {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);



  const { Course, ReferralReward, tableColumnNames, loading, Headerload, module, translationLoading } = useSelector((state) => ({
    ReferralReward: state.ReferralReward.referralReward,
    tableColumnNames: state.ReferralReward.tableColumnNames,
    loading: state.ReferralReward.loading,
    Headerload: state.ReferralReward.Headerload,
    module: state.Module.module,
    translationLoading: state.Module.translationLoading, 
}));

  // Compute permission
  const permission = (() => {
      const moduleItem = module?.find(
          (m) => m.moduleId === 9 && m.modulePermission?.CanView
        );
        const pageItem = moduleItem?.pages?.find((p) => p.pageId === 8); // Roles Management = pageId: 2
        
        if (moduleItem && pageItem) {
            return {
                CanView:
                moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
                CanAdd:
                moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
                CanEdit:
          moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
          CanDelete:
          moduleItem.modulePermission.CanDelete &&
          pageItem.permissions.CanDelete,
          CanActive:
          moduleItem.modulePermission.CanActive &&
          pageItem.permissions.CanActive,
        };
    }
    
    return {};
})();

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (referralReward, value) => {
    setSelectedRow(referralReward);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setSelectedRow((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  
  
  const onSubmitHandler = (values, { resetForm, setSubmitting }) => {

    const referralRewardObj = {
      ReferralNameEn: values.ReferralNameEn,
      ReferralNameAr: values.ReferralNameAr,
      Cash: values.Cash,
      Voucher: values.Voucher, 
      Coin: values.Coin, 
      ReferendAmount: values.ReferendAmount,
      CountryIDs: values.CountryIDs,
      DocumentURL: values.DocumentURL,
      IsPercentage: values.IsPercentage,
    };

    if (isAddOrEdit === "isEdit") {
        referralRewardObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createReferralReward(referralRewardObj)) :
      dispatch(updateReferralReward(referralRewardObj));

    resetForm();
    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchReferralRewardTableColumnNames({
          module: "REFERRALREWARD"
        })
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteReferralReward({ Ids: selectedIds }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

  const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
    if (!textToTranslate || textToTranslate.trim() === "") {
      toast.error(t("EnterTextToTranslate"));
      return;
    }
    setLastTranslatedField(sourceFieldName); 

    dispatch(fetchTranslation({ LangText: textToTranslate }))
      .unwrap() 
      .then(translatedText => {
        formikSetFieldValue(targetField, translatedText);
      })
      .catch(error => {
        console.error("Translation error:", error);
        toast.error(t("TranslationFailed"));
      })
      .finally(() => {
        setLastTranslatedField(null); 
      });
  };

  const onActiveOrDeactiveChange = (referralReward, e) => {
    dispatch(activateDeactivateReferralReward({ ID: referralReward.ID, IsActive: referralReward.IsActive}));
  };
  
  useEffect(() => {
    dispatch(fetchReferralRewardTableColumnNames({ module: "REFERRALREWARD" }))
    dispatch(fetchAllReferralReward());
    dispatch(fetchCountry());

  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("ReferralReward")} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={ReferralReward}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                     <CommonDataTable
                        data={ReferralReward || []}
                        tableColumnNames={tableColumnNames || []}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        actionConfig={actionConfig}
                        permission={permission}
                     />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
       <CommonAddModal
            show={show}
            setShow={setShow}
            onSubmitHandler={onSubmitHandler}
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedItemData={selectedRow} 
            FormBody={AddReferralRewardForm}
            FormBodyProps={{ 
              onTranslateClickHandler, 
              translationLoading,
              lastTranslatedField,
              setParentSubmitDisabled: setIsDisabled, 
            }}
            title={isAddOrEdit === "isAdd" ? t("Add New Referral Reward") : t("Edit Referral Reward")}
            size="xl" 
            isDisabled={isDisabled} 
        />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={`Are you sure you want to delete this record?`}
      />
    </div>
  );
}

export default ReferralReward;